import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { token, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#0f0d0b] text-white">
        <div className="text-center">
          <div className="w-12 h-12 rounded-full border-2 border-white/20 border-t-[#f0c95a] spin-slow mx-auto" />
          <p className="mt-4 font-sans-pro text-[11px] uppercase tracking-[0.3em] text-white/60">Verifying session…</p>
        </div>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return children;
};

export default ProtectedRoute;
